export default "__VITE_ASSET__C1EwYEmi__"